import type { ReactNode } from 'react';
import { cn } from '@tsgecart/ui';

export interface AdminContentProps {
  children: ReactNode;
  className?: string;
}

/** The scrollable main-content region -- `overflow-x-hidden` at this boundary is what keeps a too-wide table/chart from ever breaking the page's own horizontal scroll (Part 2 "safe overflow handling"). */
export function AdminContent({ children, className }: AdminContentProps) {
  return (
    <main id="admin-main-content" className={cn('mx-auto w-full max-w-7xl overflow-x-hidden px-4 py-6 sm:px-6', className)}>
      {children}
    </main>
  );
}
